export default __webpack_public_path__ + "scrollwindow-left.96457d54bc1498f4ee1503e4b3535f4e.png";